<template>
  <div class="ll-template-button-list">
    <LoadingAnimate
      v-if="isLoading"
      primary
      :size="25"
    />
    <div
      v-else
      class="ll-template-button-list_content"
    >
      <slot name="top" />
      <SearchInput
        v-if="!noSearchBar"
        v-model="searchInputButton.value"
        :placeholder="searchInputButton.placeholder"
        :text-label="searchInputButton.textLabel"
      />
      <div
        v-if="hasTitle"
        class="ll-template-button-list__title-buttons"
      >
        <div
          v-for="(templateList,templateListIndex) in buttonList"
          :key="templateListIndex"
          class="ll-template-button-list__title-button-item mt-20"
        >
          <TitleWithIcon
            :title="templateList.title"
            :subtitle="templateList.subtitle"
            :img-icon="templateList.imgIcon"
            :icon="templateList.icon"
          />
          <div class="text-buttons has-title">
            <div v-if="!$_isUserHasAuthOfSystemSubclass(templateList)">
              <WsText001 class="ml-40 my-8">
                {{ $t('您無此領域權限') }}
              </WsText001>
            </div>
            <div v-else-if="!templateList.buttonList.length">
              <WsText001 class="ml-40 my-8">
                {{ $t('此領域尚無公版') }}
              </WsText001>
            </div>
            <WsTextButton001
              v-for="(button,buttonIndex) in templateList.buttonList"
              v-else
              :key="buttonIndex"
              white
              :is-disable="button.disable"
              :to="button.router"
              @click="$_buttonClick(button)"
            >
              {{ button.name }}
            </WsTextButton001>
          </div>
        </div>
      </div>
      <div
        v-else
        class="text-buttons"
      >
        <WsTextButton001
          v-for="(template,templateIndex) in _buttonList"
          :key="templateIndex"
          white
          :is-disable="template.disable"
          :to="template.router"
          :leading-image="template.icon"
          @click="$_buttonClick(template)"
        >
          {{ $t(template.name) }}
        </WsTextButton001>
      </div>
    </div>
    <div
      v-if="bottomBtn||bottomText||returnText"
      class="ll-template-button-list_bottom-wrap"
    >
      <div
        v-if="returnText"
        class="ll-template-button-list_return-btn"
      >
        <WsTextButton001
          leading-icon="icon-chevron-back"
          no-padding
          @click=" $_bottomReturnClick()"
        >
          {{ returnText }}
        </WsTextButton001>
      </div>
      <LvFlexBox class="ll-template-button-list__bottom-right" justifyContent="center">
        <LvText
          v-if="bottomText"
          h6
          bold
          lightGray
        >{{ $t(bottomText) }}</LvText>
        <WsTextButton001
          v-if="bottomBtn"
          primary
          no-padding
          :to="bottomTo"
          @click="$_bottomBtnClick()"
        >
          {{ $t(bottomBtn) }}
        </WsTextButton001>
      </LvFlexBox>
    </div>
  </div>
</template>
<script>
import H_factorySystemClass from '@/helpers/factorySystemClass';
export default {
  name: "LlTemplateButtonList",
  props: {
    buttonList: {
      type: Array,
      default() {
        return [];
      },
    },
    bottomText: {
      type: String,
      default: "",
    },
    bottomBtn: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      default: "",
    },
    bottomTo: {
      type: String,
      default: "",
    },
    returnText: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    noSearchBar: {
      type: Boolean,
      dafault: false,
    },
    hasTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchInputButton: {
        value: "",
        placeholder: this.$t("搜尋"),
        textLabel: this.$t("搜尋"),
      },
    };
  },
  computed: {
    _buttonList() {
      let orginalButtons = [...this.buttonList];
      if (this.searchInputButton.value) {
        const searchText = this.searchInputButton.value;
        const buttonSearch = orginalButtons.filter(
          (button) => button.name.indexOf(searchText) > -1
        );
        return buttonSearch;
      } else {
        return orginalButtons;
      }
    },
  },
  methods: {
    $_buttonClick(button) {
      if (!button.disable) {
        this.$emit("click", button);
      }
    },
    $_bottomBtnClick() {
      this.$emit("bottom-click");
    },
    $_bottomReturnClick() {
      this.$emit("bottom-return-click");
    },
    $_isUserHasAuthOfSystemSubclass(templateList) {
      if (templateList.subclassId === undefined) return true
      return H_factorySystemClass.hasSystemSubclassScope(
        templateList.subclassId,
        this.$store.state.app.factoryId,
      );
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/ll-template-button-list";
</style>